module.exports = __webpack_public_path__ + "img/blockstory-banner.157fafbb.png";